export default {
    getSpidLevel(state) {
        return state.spidLevel;
    },
    getSpName(state) {
        return state.spName;
    },
    getProfile(state) {
        return state.profile;
    }
}
